import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ActionsFlagHighlightedXsmall from '@strava/icons/ActionsFlagHighlightedXsmall';
import Button from '@strava/ui/Button';
import colors from '@strava/ui/colors';
import { useFeedEntityContext } from '../../../../state/FeedEntityContext';

import styles from '../index.scss';
import { useFeedContext } from '../../../../state/FeedContext';
import { REGISTER_FEED_ENTRY_UI_CHANGE } from '../../../../state/feed-actions';

const ELLIPSIS = '•••';
const MAX_LENGTH = 350;

const ActivityTextBody = ({
  activityId,
  activityName,
  ownedByCurrentAthlete,
  flagged,
  description
}) => {
  const { entityState } = useFeedEntityContext();
  const { dispatch: dispatchFeed } = useFeedContext() || { dispatch: () => {} }; // TODO remove dummy dispatch for feed without container
  const [readMore, setReadMore] = useState(false);

  const isExpandable = description && description.length > MAX_LENGTH;

  const splitDescription = (() => {
    if (description) {
      // remove all html tags from description
      const regex = /(<([^>]+)>)/gi;
      const cleanDescription = description.trim().replace(regex, '');

      if (cleanDescription.length < MAX_LENGTH) {
        return [cleanDescription, ''];
      }
      // trim the string to the maximum length
      let firstSection = cleanDescription.substr(0, MAX_LENGTH);
      // re-trim if we are in the middle of a word
      firstSection = firstSection.substr(
        0,
        Math.min(firstSection.length, firstSection.lastIndexOf(' '))
      );
      return [firstSection, cleanDescription.substr(firstSection.length)];
    }
    return ['', ''];
  })();

  return (
    <>
      {/* Title Text */}
      <h3 className={`text-title-1 ${styles.activityName}`}>
        <a
          href={`/activities/${activityId}`}
          className={styles.activityName}
          data-testid="activity_name"
          onClick={() => {
            entityState.trackAnalytics({
              action: 'click',
              properties: { element_source: 'title' }
            });
          }}
        >
          {activityName}
        </a>
        {ownedByCurrentAthlete && flagged && (
          <span className={styles.iconWrapper}>
            <ActionsFlagHighlightedXsmall
              fill={colors.BRAND_DANGER}
              data-testid="activity_flag"
            />
          </span>
        )}
      </h3>

      {/* Activity Description */}
      {description && (
        <div className={styles.descriptionBody}>
          <div
            className={styles.wrapper}
            data-testid="activity_description_wrapper"
          >
            <a
              href={`/activities/${activityId}`}
              data-testid="activity_description"
            >
              {splitDescription[0]}
              {readMore && splitDescription[1]}
            </a>
          </div>
          {isExpandable && (
            <div className={styles.descriptionReadMore}>
              <Button
                data-testid="activity_description_read_more"
                tabIndex={0}
                type="button"
                onClick={() => {
                  setReadMore(!readMore);
                  dispatchFeed({
                    type: REGISTER_FEED_ENTRY_UI_CHANGE
                  });
                }}
              >
                {ELLIPSIS}
              </Button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

ActivityTextBody.propTypes = {
  activityId: PropTypes.string.isRequired,
  activityName: PropTypes.string.isRequired,
  ownedByCurrentAthlete: PropTypes.bool,
  flagged: PropTypes.bool,
  description: PropTypes.string
};

ActivityTextBody.defaultProps = {
  ownedByCurrentAthlete: false,
  flagged: false,
  description: PropTypes.string
};

export default ActivityTextBody;
